import {US_STATES} from 'src/app/_common/us-states';

export class Endorsement {
    /* Development purpose */
    policyCanEndorse: boolean = false;
    selectedStep: string;

    ACCOUNT = [
        {id: 1, uid:"account1", type:"ACCOUNT", actualTypeDisplayName:"Account Updates", endorsementType: "MAILINGADDRESS", displayName: "Mailing Address", isSelected: false, canAddMore:false, forms:[new MailingAddressForm()]},
        {id: 2, uid:"account2", type:"ACCOUNT", actualTypeDisplayName:"Account Updates", endorsementType: "NAMEDINSURED", displayName: "Named Insured", isSelected: false, canAddMore:true, forms:[new NamedInsuredForm()]}
    ];
    OTHER = [
        {id: 1, uid:"other1", type:"OTHER", actualTypeDisplayName:"Other Request", endorsementType: "OTHER", displayName: "Other", isSelected: false, canAddMore:false, forms:[new OtherForm()]}
    ]
    AU = [
        {id: 1,  uid:"auto1", type:"AU", actualTypeDisplayName:"Commercial Auto", endorsementType: "VEHICLEEXPOSUREANDCOVERAGES", displayName: "Vehicle Exposure & Coverages", isSelected: false, canAddMore:true, forms:[new VehicleExposureAndCoveragesForm()]},
        {id: 2,  uid:"auto2", type:"AU", actualTypeDisplayName:"Commercial Auto", endorsementType: "MONTHLYREPORTER", displayName: "Monthly Reporter", isSelected: false, canAddMore:false, forms:[new MonthlyReporterForm()]},
        {id: 3,  uid:"auto3", type:"AU", actualTypeDisplayName:"Commercial Auto", endorsementType: "GARAGINGLOCATION", displayName: "Garaging Location", isSelected: false, canAddMore:true, forms:[new GaragingLocationForm()]},
        {id: 4,  uid:"auto4", type:"AU", actualTypeDisplayName:"Commercial Auto", endorsementType: "DRIVERREVIEW", displayName: "Driver Review", isSelected: false, canAddMore:false, forms:[new DriverReviewForm()]},
        {id: 5,  uid:"auto5", type:"AU", actualTypeDisplayName:"Commercial Auto", endorsementType: "ADDITIONALINTEREST", displayName: "Additional Interest", isSelected: false, canAddMore:true, forms:[new AdditionalInterestForm()]}
    ];
    BOP = [
        {id: 1,  uid:"bop1", type:"BOP", actualTypeDisplayName:"Business Owners Policy", endorsementType: "COVERAGES", displayName: "Coverages", isSelected: false, canAddMore:true, forms:[new BOPCoveragesForm()]},
        {id: 2,  uid:"bop2", type:"BOP", actualTypeDisplayName:"Business Owners Policy", endorsementType: "BUILDINGANDLOCATION", displayName: "Building & Location", isSelected: false, canAddMore:true, forms:[new BuildingAndLocationForm()]},
        {id: 3,  uid:"bop3", type:"BOP", actualTypeDisplayName:"Business Owners Policy", endorsementType: "ADDITIONALINTEREST", displayName: "Additional Interest", isSelected: false, canAddMore:true, forms:[new AdditionalInterestForm()]}
    ];
    CR = [
        {id: 1,  uid:"crime1", type:"CR", actualTypeDisplayName:"Crime", endorsementType: "COVERAGES", displayName: "Coverages", isSelected: false, canAddMore:true, forms:[new CoveragesForm()]},
        {id: 2,  uid:"crime2", type:"CR", actualTypeDisplayName:"Crime", endorsementType: "LOCATION", displayName: "Location", isSelected: false, canAddMore:true, forms:[new LocationForm()]}
    ];
    GL = [
        {id: 1,  uid:"generalliability1", type:"GL", actualTypeDisplayName:"General Liability", endorsementType: "CLASSEXPOSUREANDCOVERAGES", displayName: "Class Exposure & Coverages", isSelected: false, canAddMore:true, forms:[new ClassExposureForm()]},
        {id: 2,  uid:"generalliability2", type:"GL", actualTypeDisplayName:"General Liability", endorsementType: "ADDITIONALINTEREST", displayName: "Additional Interest", isSelected: false, canAddMore:true, forms:[new AdditionalInterestForm()]},
        {id: 3,  uid:"generalliability3", type:"GL", actualTypeDisplayName:"General Liability", endorsementType: "LOCATION", displayName: "Location", isSelected: false, canAddMore:true, forms:[new LocationForm()]}
    ];
    IM = [
        {id: 1,  uid:"inlandmarine1", type:"IM", actualTypeDisplayName:"Inland Marine", endorsementType: "COVERAGESANDLIMITS", displayName: "Coverages & Limits", isSelected: false, canAddMore:true, forms:[new CoveragesAndLimitsForm()]},
        {id: 2,  uid:"inlandmarine2", type:"IM", actualTypeDisplayName:"Inland Marine", endorsementType: "ADDITIONALINTEREST", displayName: "Additional Interest", isSelected: false, canAddMore:true, forms:[new AdditionalInterestForm()]},
        {id: 3,  uid:"inlandmarine3", type:"IM", actualTypeDisplayName:"Inland Marine", endorsementType: "BUILDINGANDLOCATION", displayName: "Building & Location", isSelected: false, canAddMore:true, forms:[new BuildingAndLocationForm()]}
    ];
    PL = [
        {id: 1,  uid:"professionalliability1", type:"PL", actualTypeDisplayName:"Professional Liability", endorsementType: "COVERAGES", displayName: "Coverages", isSelected: false, canAddMore:true, forms:[new CoveragesForm()]},
        {id: 2,  uid:"professionalliability2", type:"PL", actualTypeDisplayName:"Professional Liability", endorsementType: "LOCATION", displayName: "Location", isSelected: false, canAddMore:true, forms:[new LocationForm()]}
    ];
    PR = [
        {id: 1,  uid:"property1", type:"PR", actualTypeDisplayName:"Property", endorsementType: "COVERAGESANDLIMITS", displayName: "Coverages & Limits", isSelected: false, canAddMore:true, forms:[new PropertyCoveragesAndLimitsForm()]},
        {id: 2,  uid:"property2", type:"PR", actualTypeDisplayName:"Property", endorsementType: "BUILDINGANDLOCATION", displayName: "Building & Location", isSelected: false, canAddMore:true, forms:[new BuildingAndLocationForm()]},
        {id: 3,  uid:"property3", type:"PR", actualTypeDisplayName:"Property", endorsementType: "ADDITIONALINTEREST", displayName: "Additional Interest", isSelected: false, canAddMore:true, forms:[new AdditionalInterestForm()]}
    ];
    UM = [
        {id: 1,  uid:"umbrella1", type:"UM", actualTypeDisplayName:"Umbrella", endorsementType: "RETAINEDLIMITSANDUNDERLIERS", displayName: "Retained Limits & Underliers", isSelected: false, canAddMore:true, forms:[new RetainedLimitsAndUnderliersForm()]}
    ];
    EX = [
        {id: 1,  uid:"excess1", type:"EX", actualTypeDisplayName:"Excess", endorsementType: "RETAINEDLIMITSANDUNDERLIERS", displayName: "Retained Limits & Underliers", isSelected: false, canAddMore:true, forms:[new RetainedLimitsAndUnderliersForm()]}
    ];
    WC = [
        {id: 1,  uid:"workerscomp1", type:"WC", actualTypeDisplayName:"Workers Compensation", endorsementType: "CLASSEXPOSURE", displayName: "Class Exposure", isSelected: false, canAddMore:true, forms:[new WCClassExposureForm()]},
        {id: 2,  uid:"workerscomp2", type:"WC", actualTypeDisplayName:"Workers Compensation", endorsementType: "ENTITYANDLOCATION", displayName: "Entity & Location", isSelected: false, canAddMore:true, forms:[new EntityAndLocationForm()]}
    ];

    /* Development purpose */

    /* below JSON will be sent in Submit request */
    submittedDate: string = new Date().toDateString();
    policyLobType: string = "";
    accountName: string = "";
    accountNumber: string = "";
    policyNumber: string = "";
    policyNicheName: string = "";
    effectiveDate: string;
    policyEffectiveDate: Date;
    policyExpirationDate: Date;
    policyCancelDate: Date;
    summary: string = "";
    supportingDocuments = [];
    
    isAcordForm: boolean = null;
    isQuote: boolean = null;
    
    EndorsementForm = {};
    hasAccountLevelEndorsement: boolean = false;
    /* above JSON will be sent in Submit request */

    

}

export class EndorsementMethod{
    getEndorsementTypes(_endorsement:Endorsement){
        return [_endorsement.ACCOUNT, _endorsement.AU, _endorsement.BOP, _endorsement.CR, _endorsement.EX, _endorsement.GL, _endorsement.IM, _endorsement.PL, _endorsement.PR, _endorsement.UM, _endorsement.WC, _endorsement.OTHER];
    }
    
    getFinalEndorsement(_endorsement:Endorsement){
        let finalEndorsement = { 
            submittedDate: _endorsement.submittedDate,
            policyLobType: _endorsement.policyLobType,
            accountName: _endorsement.accountName, 
            accountNumber: _endorsement.accountNumber, 
            policyNumber: _endorsement.policyNumber,
            policyNicheName: _endorsement.policyNicheName,
            effectiveDate: _endorsement.effectiveDate,
            policyEffectiveDate: _endorsement.policyEffectiveDate,
            policyExpirationDate: _endorsement.policyExpirationDate,
            policyCancelDate: _endorsement.policyCancelDate,
            summary: _endorsement.summary,
            supportingDocuments: _endorsement.supportingDocuments,
            isAcordForm: _endorsement.isAcordForm,
            isQuote: _endorsement.isQuote,
            EndorsementForm: _endorsement.EndorsementForm,
            hasAccountLevelEndorsement: _endorsement.hasAccountLevelEndorsement
        };

        return finalEndorsement;
    }
}

/* Account */
export class MailingAddressForm{
    insuredName: string = "";
    location = {
        streetAddress: "",
        streetAddress2: "",
        city: "",
        state: "",
        zipCode: ""
    }
    additionalInformation: string = "";
}
export class NamedInsuredForm{
    currentNamedInsured: string = "";
    namedInsuredToBe: string = "";
    additionalNamedInsureds = [new AdditionalNamedInsureds()];    
}
export class AdditionalNamedInsureds{
    action: string = ""; //Add, Update, Delete
    currentAdditionalNamedInsured: string = "";
    additionalNamedInsuredToBe: string = "";
}
export class OtherForm{
    additionalInformation: string = "";
}
/* Account */


/* Common */
export class LocationForm{
    action: string = "";
    
    currentLocation = {
        streetAddress: "",
        streetAddress2: "",
        city: "",
        state: "",
        zipCode: ""
    }

    updatedLocation = {
        streetAddress: "",
        streetAddress2: "",
        city: "",
        state: "",
        zipCode: ""
    }

    additionalInformation: string = "";
}

export class AdditionalInterestForm{
    action: string = "";
    additionalInterestType: string = "";
    referenceNumber: string = "";
    additionalInterestName: string = "";
    
    location = {
        streetAddress: "",
        streetAddress2: "",
        city: "",
        state: "",
        zipCode: ""
    }
    additionalInformation: string = "";
}
/* Account */

/* AUTO */
export class VehicleExposureAndCoveragesForm{
    type: string = "";
    
    location = {
        streetAddress: "",
        streetAddress2: "",
        city: "",
        state: "",
        zipCode: ""
    }
    vehicles = [new Vehicle()];
    additionalInformation: string = ""
}
export class Vehicle {
    action: string = "";
    vin: string = "";
    additionalInterestType: string = "";
    referenceNumber: string = "";
    additionalInterestName: string = "";

    location = {
        streetAddress: "",
        streetAddress2: "",
        city: "",
        state: "",
        zipCode: ""
    };
    coverages: string = "";
}
export class GaragingLocationForm extends LocationForm{
}

export class MonthlyReporterForm{
    monthlyReportDocuments: [] = [];
    additionalInformation: string = "";
}
export class DriverReviewForm{
    driverReviewDocuments: [] = [];
    additionalInformation: string = "";
}
//additionalInterest
/* Account */


/* GL */
export class ClassExposureForm{
    type: string = "";
    
    location = {
        streetAddress: "",
        streetAddress2: "",
        city: "",
        state: "",
        zipCode: ""
    }
    classExposures = [new AnotherClassExposure()];
    additionalInformation: string = ""
}

export class AnotherClassExposure{
    action: string = "";
    classDescription: string = "";
    classCode: string = "";
    exposure: string = "";
    premiumBasis: string = "";
    coverages: string = "";
}
//Location
//AdditionalInterest
/* GL */


/* PL, CR */
export class CoveragesForm{
    type: string = "";
    
    location = {
        streetAddress: "",
        streetAddress2: "",
        city: "",
        state: "",
        zipCode: ""
    }
    coverages = [new AnotherCoveragesForm()];
    additionalInformation: string = ""
}
export class AnotherCoveragesForm{
    action: string = "";
    coverageName: string = "";
    coverageDetails: string = "";
}
/* PL */

/* BOP */
export class BOPCoveragesForm extends CoveragesForm{
    buildingNumber: string = "";
    buildingOccupancy: string = "";
    buildingDetails: string = "";
}
//LocationForm
//AdditionalInterestForm
/* BOP */

/* IM */
export class CoveragesAndLimitsForm extends CoveragesForm{
    buildingNumber: string = "";
    buildingOccupancy: string = "";
    buildingDetails: string = "";
    coverages = [new IMPRCoverages()];
}
export class BuildingAndLocationForm extends LocationForm{
    buildingNumber: string = "";
    buildingOccupancy: string = "";
    buildingDetails: string = "";
}
//AdditionalInterestForm
/* IM */

export class IMPRCoverages {
    action: string = "";
    coverageName: string = "";
    coverageLimit: string = "";
    coverageDeductible: string = "";
    coverageDetails: string = "";
}

/* PR */
export class PropertyCoveragesAndLimitsForm extends CoveragesForm{
    buildingNumber: string = "";
    buildingOccupancy: string = "";
    buildingDetails: string = "";
    coverages = [new IMPRCoverages()];
}
//BuildingAndLocationForm
//AdditionalInterestForm
/* PR */

/* UM, EX */
export class RetainedLimitsAndUnderliersForm {
    action: string = "";
    underlyingCoverage: string = "";
    retainedLimit: string = "";
    underlyingPremium: string = "";
    coverageDetails: string = "";
    additionalInformation: string = "";
}
/* UM, EX */

/* WC */
export class WCClassExposureForm{
    type: string = "";
    entityName: string = "";
    
    location = {
        streetAddress: "",
        streetAddress2: "",
        city: "",
        state: "",
        zipCode: ""
    }
    classExposures = [new AnotherWCClassExposure()];
    additionalInformation: string = "";
}
export class AnotherWCClassExposure{
    action: string = "";
    classDescription: string = "";
    classCode: string = "";
    payrollOrEmployees: string = "";
    payrollEmployeeAmount: string = "";
}
export class EntityAndLocationForm extends LocationForm{
    entityName: string = "";
}
/* WC */
